import Typography from '@mui/material/Typography';
import type { SxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { Children } from '@repo/shared/types';

interface SectionHeaderProps extends Children {
  sx?: SxProps<Theme>;
}

export function SectionHeader({ children, sx }: SectionHeaderProps) {
  return (
    <Typography component="p" sx={sx} variant="h5">
      {children}
    </Typography>
  );
}
